import React, { useState, useEffect } from 'react'
import { formatPrice, formatPricewithdecimal } from '../../../../../NumberFormat';
import { withTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import ErrorCodePopup from '../../../../../Popups/ErrorCodePopup';
import { IoMdClose } from "react-icons/io";

const BbfsPopup = (props) => {
  const { onClose, submitResult } = props;

  const [label, setLabel] = useState('');
  const [label1, setLabel1] = useState('');
  const [totalPay, setTotalPay] = useState('');
  const [successResultData, setSuccessResultData] = useState([]);
  const [canceledResultData, setCanceledResultData] = useState([]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  useEffect(() => {
    if (submitResult.processLabel && submitResult.game_name) {
      // setLabel('Process Done (' + submitResult.processLabel + ' - ' +submitResult.game_name +') >>');
      setLabel(`${props.t('process_done')} (${submitResult.processLabel} - ${submitResult.game_name})`);
      setLabel1(`${props.t('period')}` + ': ' + (submitResult.nextPeriode) + ' - ' + submitResult.game_code);
      setTotalPay(Math.round(submitResult.totalbayar));
    }

    if (submitResult.datasuccess) {
      const dataArray = Object.values(submitResult.datasuccess)[0];
      const data = dataArray.map((element, index) => ({
        no: ++index,
        bet: element.bet,
        position: element.bet_type,
        amount: formatPrice(element.amount),
        discount: element.disc,
        pay: formatPrice(Math.round(element.bayar)),
        totalWin: formatPrice(element.totalWin)
      }));
      setSuccessResultData(data);
    }

    if (submitResult.datafailed) {
      const dataArray = Object.values(submitResult.datafailed)[0];
      const data = dataArray.map((element, index) => ({
        no: ++index,
        bet: element.bet,
        position: element.bet_type,
        amount: formatPrice(element.amount),
        red: element.red,
        info: element.red === 20 ? `${props.t("Eliminate")}` : (element.red === 14 ? `${props.t("Removed")}` : (element.red === 22 ? `${props.t("Eliminate")}` : "")),
      }));
      setCanceledResultData(data);
    }
  }, [submitResult.datasuccess, submitResult.datafailed]);

  const handlePopupOpen = (redValue) => {
    let message;
    let code = '';
    code = 'code' + redValue;
    let popupMessage = props.t(code);
    setPopupMessage(popupMessage);
    setIsPopupOpen(true);
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
    setPopupMessage('');
  };

  return (
    <div className="overlay">
      <div className='overlay_innerDiv' onClick={onClose}></div>
      <div className="bbfs_popup">
        <button className="informasi_popup-close" onClick={onClose}>
          <IoMdClose className="btnclose"/>
        </button>
        <div className="bbfs_popup_titleone">{label}</div>
        <div className='trasaction_popup'>
          {canceledResultData.length > 0 && (
            <>
              <div className="bbfs_popup_titletwo">{label1} {props.t('Cancelled')}</div>
              <div className="informasi_tble_result statement_tble_result">
                <table >
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>{props.t('bet')}</th>
                      <th>{props.t('position')}</th>
                      <th>{props.t('amount')}</th>
                      <th>{props.t('error_code')}</th>
                      <th>{props.t('Information')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {canceledResultData.map((data, index) => (
                      <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                        <td>{data.no}</td>
                        <td><strike>{data.bet}</strike></td>
                        <td><strike>{data.position}</strike></td>
                        <td><strike>{data.amount}</strike></td>
                        {/* <td>{props.t('click_here')} ({data.red})</td> */}
                        <td className="inputs" style={{ cursor: "pointer" }}>
                          <a onClick={() => handlePopupOpen(data.red)}>
                            {props.t('click_here')} ({data.red})
                          </a>
                        </td>
                        <td className="inputs" style={{ color: 'red' }}>
                          {data.red == 14 ? props.t("Removed") : props.t("Eliminate")}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {successResultData.length > 0 && (
            <>
              <div className="bbfs_popup_titletwo">{label1} Success</div>
              <div className="informasi_tble_result statement_tble_result">
                <table >
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>{props.t('bet')}</th>
                      <th>{props.t('position')}</th>
                      <th>{props.t('amount')}</th>
                      <th>{props.t('discount')} (%)</th>
                      <th>{props.t('pay')}</th>
                      <th>{props.t('totalWin')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {successResultData.map((data, index) => (
                      <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                        <td>{data.no}</td>
                        <td>{data.bet}</td>
                        <td>{data.position}</td>
                        <td>{data.amount}</td>
                        <td>{data.discount}%</td>
                        <td>{data.pay}</td>
                        <td>{data.totalWin}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          <div className='bbfs_popup_total'>Total {props.t('player_pay')} : {formatPrice(totalPay)}</div>
        </div>
      </div>
      {isPopupOpen &&
        (<ErrorCodePopup onClose={handlePopupClose} message={popupMessage} />)
      }
    </div>
  );
};

export default withTranslation()(BbfsPopup);
